import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { BiTrash } from 'react-icons/bi'
import Table from '../../components/Table'
import Confirmation from '../../components/Confirmation/Confirmation'
import ModalSubField from './ModalSubField'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'


const validationSchema = Yup.object({
  dsname: Yup.string().required('обязательное поле'),
  dstranslate: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  dsdescript: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, addMode }) {

  const dispatch = useDispatch()

  const { fieldAllList, fields } = useSelector(state => state.datasets)
  const [selectedField, setSelectedField] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [newFields, setNewFields] = useState([]);

  useEffect(() => { setNewFields(fields) }, [fields])

  const openModalSubField = (data) => () => {
    setSelectedField(data || {})
  }
  const closeSubModal = () => {
    setSelectedField(null)
  }
  const acceptConfirmation = () => {
    closeModal();
    // dispatch(deleteStudyShift(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { fnum, fname, linked_dataset_id, fdefault, ftype, fisnull, finprimarykey, fisidentity } = data
    return (
      <tr>
        <td >{fnum}</td>
        <td onClick={openModalSubField(data)}>{fname}</td>
        <td onClick={openModalSubField(data)}>{fdefault}</td>
        <td onClick={openModalSubField(data)}>{fisnull}</td>
        <td onClick={openModalSubField(data)}>{fnum}</td>
        <td onClick={openModalSubField(data)}>{fisnull}</td>
        <td onClick={openModalSubField(data)}>{finprimarykey}</td>
        <td onClick={openModalSubField(data)}>{fisidentity}</td>
        <td onClick={openModalSubField(data)}>{fnum}</td>
        <td onClick={openModalSubField(data)}>{linked_dataset_id}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: fnum, name: fname })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        modal: styles.custom
      }}
    >
      <>
        {selectedField &&
          <ModalSubField
            closeModal={closeSubModal}
            data={selectedField}
            datasetId={data}
            height={'430px'}
            width={'1200px'}
            addMode={!selectedField?.field_id}
          />
        }
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            {confirmation && (
              <Confirmation
                top="30px"
                left="40px"
                title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
                acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
                rejectConfirmation={rejectConfirmation}
              />
            )}
            <Table className={styles.tables}>
              <thead>
                <tr>
                  <th>№ п/п</th>
                  <th>Название</th>
                  <th>Значение</th>
                  <th>Описание</th>
                  <th>Тип</th>
                  <th>По умолч.</th>
                  <th>Знач. null</th>
                  <th>Перв. ключ</th>
                  <th>Автоинкремент</th>
                  <th>Ссылка на табл.</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>

                {newFields?.map(renderLi)}

              </tbody>
            </Table>

          </div>
          <Button
            style={{ padding: '.5rem 1.5rem', margin: '12px' }}
            onClick={openModalSubField()}
          >
            <IoIosAdd size={30} />
            Добавить
          </Button>
        </div>

        <ModalFooter handleSubmit={() => { }} closeModal={closeModal} />
      </>
    </Modal>

  )
}
